import { render, staticRenderFns } from "./sexStatistics.vue?vue&type=template&id=502b10c9&scoped=true&"
import script from "./sexStatistics.vue?vue&type=script&lang=js&"
export * from "./sexStatistics.vue?vue&type=script&lang=js&"
import style0 from "./sexStatistics.vue?vue&type=style&index=0&id=502b10c9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b10c9",
  null
  
)

export default component.exports